// ✅ No "use client" — pure Server Component
import { Suspense } from "react";
import dynamic from "next/dynamic";
import { useTranslations, useLocale } from "next-intl";
import { MdEmail } from "react-icons/md";
import Image from "next/image";
import { Link } from "@/i18n/routing";

// Isolate the client-only widget — rest of footer streams as SSR HTML
import LanguageSelectClient from "./language-select-client";


const End = () => {
  const t = useTranslations('Footer');
  const th = useTranslations('Padel-Master-The-Game-Home-Page');
  const l = useLocale();

  return (
    <footer className="relative pt-10 bg-[#242621] text-yel overflow-hidden select-none">

      <div className="container mx-auto px-6 pb-20 pt-10 flex flex-col flex-wrap items-center justify-center select-none" id="contact">
        <div className="max-w-4xl">
          <p className="mb-4 fade-up-2 text-xl xl:text-2xl 2xl:text-3xl font-extrabold text-white uppercase leading-none">
            {th('title8')}<br />
          </p>
          <p className="text-base  text-white">{th('t8-1')}</p>

          <p className="font-medium text-b hover:underline flex items-center gap-1 pt-2 text-end">
            <MdEmail size={24} />
            <a href="mailto:contact@padelmasterthegame.com" className="text-lg">
              contact@padelmasterthegame.com
            </a>
          </p>

          <p className="text-base  text-white mt-4">{th('t8-2')}</p>
          <p className="text-base  text-white mt-4 font-medium">{th('t8-3')}</p>
          <p className="text-base  text-white mt-4">{th('t8-4')}</p>
          <p className="text-base  text-white mt-4">{th('t8-5')}</p>

          {/* priority ensures this loads with the initial HTML, not after JS */}
          <Image
            src="/sign.svg"
            alt="signature"
            width={180}
            height={60}
            className="invert"
            priority
          />

          <p className="text-white">{th('t8-6')}</p>
          <p className="text-white">{th('t8-7')}</p>
        </div>

        <div className="space-y-2 text-white flex flex-col justify-center items-center mt-16">
          <div className="flex gap-x-6 flex-wrap">
            <Link href="/privacy-policy"><p className="cursor-pointer underline hover:text-b">{t('Privacy Policy')}</p></Link>
            <Link href="/terms-and-conditions"><p className="cursor-pointer underline hover:text-b">{t('Terms and Conditions')}</p></Link>
            <Link href="/refund-policy"><p className="cursor-pointer underline hover:text-b">{th('Refund-Policy')}</p></Link>
            <Link href="/contact-us"><p className="cursor-pointer underline hover:text-b">{th('Contact-Us')}</p></Link>
          </div>

          <p className="flex gap-2 items-center text-xl font-light">{th('Copyright')} &copy; 2026</p>

          <div className="flex gap-1 pt-1 mt-6">
            <p className="text-b text-xs font-medium">{th('Developed')}</p>
            <Link href="/" rel="preload">
              <div className="relative h-3 w-20">
                <Image
                  src="/evinov.avif"
                  alt="evinov"
                  fill
                  sizes="80px"
                  style={{ objectFit: 'contain' }}
                  priority
                />
              </div>
            </Link>
          </div>
        </div>
      </div>

      <hr className="container mx-auto px-6" />

      <div className="flex flex-wrap justify-between gap-6 items-center pt-6 pb-8 container mx-auto px-6">
        <div />

        <div className="flex flex-wrap gap-4 items-center">
          <div>
            <p className="text-xs text-white mb-1">{th('Secure')}</p>
            <div className="flex gap-3 justify-center">
              {[1, 2, 3, 4, 5].map(i => (
                <Image
                  key={i}
                  src={`/payment/${i}.png`}
                  alt={`payment-${i}`}
                  width={30}
                  height={10}
                  priority  // ← these are above the fold on most viewports
                />
              ))}
            </div>
          </div>

          <div className="self-stretch w-px bg-white/20" />

          <a href="https://paddle.com/legal/" rel="noopener noreferrer">
            <Image src="/payment/paddle.svg" alt="Paddle" width={100} height={40} loading="eager" />
          </a>

          <div className="self-stretch w-px bg-white/20" />

          <a href="https://btcpayserver.org/" target="_blank" rel="noopener noreferrer">
            <Image src="/payment/btcpay-server.svg" alt="BTCPay Server" width={20} height={20} loading="eager" />
          </a>
        </div>

        <div className="flex justify-end items-end text-end">
          {/* Suspense boundary keeps the server HTML intact while LanguageSelect hydrates */}
         <LanguageSelectClient />

        </div>
      </div>

    </footer>
  );
};

export default End;